import CloseIcon from '@mui/icons-material/Close';
import { Divider, IconButton, Link, Typography } from '@mui/material';
import { ReactComponent as ExternalIcon } from 'assets/img/external-link.svg';
import LocaleSelector from 'components/LocaleSelector';
import { Fragment } from 'react';
import { setupCurrentOriginUrl } from 'utils/contentUtils';
import MobileMainMenu from './MobileMainMenu';

const MobileMenu = ({
  menuItems,
  topHeaderMenu,
  topHeaderItems,
  toggleMenu,
  locales,
  currentLocale,
  backButtonLabel,
  closeButtonLabel,
}) => (
  <nav
    className="d-lg-none overflow-y-auto p-3 position-fixed top-0 start-0 end-0 bottom-0 h-100 w-100 bg-body border-bottom"
    style={{ zIndex: 2000 }}
  >
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-end">
            <IconButton onClick={toggleMenu} aria-label={closeButtonLabel}>
              <CloseIcon className="fs-3" />
            </IconButton>
          </div>
          <Divider className="w-100 mt-2 opacity-100" />
        </div>
        <div className="col-12">
          <LocaleSelector locales={locales} currentLocale={currentLocale} />
          <Divider className="w-100 opacity-100" />
        </div>
        {Array.isArray(menuItems) && menuItems.length > 0 && (
          <div className="col-12">
            <MobileMainMenu items={menuItems} backLabel={backButtonLabel} />
          </div>
        )}
        {Array.isArray(topHeaderItems) && topHeaderItems.length > 0 && (
          <div className="col-12">
            <div className="w-100">
              {topHeaderItems.map(({ id, label, href }, i) => {
                const itemUrl = setupCurrentOriginUrl(href);
                return (
                  <Fragment key={id}>
                    <Link
                      href={itemUrl ?? '#'}
                      underline={itemUrl != null ? 'hover' : 'none'}
                      className="d-flex align-items-center gap-2 fs-7 py-2"
                      onClick={itemUrl != null ? undefined : (e) => e.preventDefault()}
                      color="black"
                      sx={i === 0 ? { color: '#e20074' } : { color: '#616161', ':hover': { color: '#e20074' } }}
                    >
                      <Typography component="span" variant="body2" color="inherit">
                        {label}
                      </Typography>
                      <ExternalIcon />
                    </Link>
                    <Divider className="w-100 opacity-100" />
                  </Fragment>
                );
              })}
            </div>
          </div>
        )}
        {Array.isArray(topHeaderMenu) && topHeaderMenu.length > 0 && (
          <div className="col-12">
            <div className="w-100">
              {topHeaderMenu.map(({ id, label, href }) => {
                const itemUrl = setupCurrentOriginUrl(href);
                return (
                  <Fragment key={id}>
                    <Link
                      href={itemUrl ?? '#'}
                      underline={itemUrl != null ? 'hover' : 'none'}
                      className="d-block fs-7 py-2"
                      onClick={itemUrl != null ? undefined : (e) => e.preventDefault()}
                      sx={{ color: '#616161', ':hover': { color: '#e20074' } }}
                    >
                      <Typography component="span" variant="body2" color="inherit">
                        {label}
                      </Typography>
                    </Link>
                    <Divider className="w-100 opacity-100" />
                  </Fragment>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  </nav>
);
export default MobileMenu;
